<template>
    <a-modal v-model="visible" width="900px" :title="$t('web.download_center' /* 下载任务中心 */)"  centered @cancel="visible = false" class="modal-box" @ok="handleOk">
        <a-spin :spinning="spinning" tip="Loading...">
            <div class="goods-box">
                <div v-for="(item, index) in typeList" :key="index" class="goods-item">
                    <div class="type-title bold flex">
                        <div>{{ item.name }}</div>
                    </div>
                    <!-- 一级 -->
                    <template v-if="!item.children || item.children.length == 0">
                        <a-table
                            v-if="dataSource.filter(it => it.type_id == item.id).length > 0"
                            ref="table"
                            class="mt15"
                            :rowKey="record => record.id"
                            :columns="columns"
                            :data-source="dataSource.filter(it => it.type_id == item.id)"
                            :pagination="false"
                            size="small"
                            :expand-icon-column-index="1"
                            :defaultExpandAllRows="true"
                            :row-selection="rowSelection">
                            <span slot="name" slot-scope="text, record">
                                {{ text }}
                            </span>
                            <span slot="inventory" slot-scope="text, record">
                                <!-- 库存 -->
                                <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                                <!-- 销量 -->
                                <span>/{{ record.sale_num }}</span>
                            </span>
                            <span slot="price" slot-scope="text, record">
                                {{ currencyType[record.currency] }} :
                                {{ record.price }}
                            </span>
                            <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>
                        </a-table>
                    </template>
                    <!-- 二级 -->
                    <template v-if="item.children && item.children.length > 0">
                        <div v-for="(it, inde) in item.children" class="pl20 pr20" :key="inde">
                            <div class="type-title bold flex mt15">
                                <div>{{ it.name }}</div>
                            </div>
                            <a-table
                                ref="table"
                                class="mt15"
                                :rowKey="record => record.id"
                                :columns="columns"
                                v-if="dataSource.filter(goods => goods.type_id == it.id).length > 0"
                                :data-source="dataSource.filter(goods => goods.type_id == it.id)"
                                :pagination="false"
                                size="small"
                                :expand-icon-column-index="1"
                                :defaultExpandAllRows="true"
                                :row-selection="rowSelection">
                                <span slot="name" slot-scope="text, record">
                                    {{ text }}
                                </span>
                                <span slot="inventory" slot-scope="text, record">
                                    <!-- 库存 -->
                                    <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                                    <!-- 销量 -->
                                    <span>/{{ record.sale_num }}</span>
                                </span>
                                <span slot="price" slot-scope="text, record">
                                    {{ currencyType[record.currency] }} :
                                    {{ record.price }}
                                </span>
                                <span slot=""></span>
                                <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>
                            </a-table>
                        </div>
                    </template>
                </div>
            </div>
        </a-spin>
    </a-modal>
</template>

<script>
import { currencyType } from '@/config/const.js';
export default {
    name: 'Goods',
    components: {
    },
    data() {
        return {
            typeList: [], // 门票类型
            currencyType,
            visible: false,
            spinning: false,
            columns: [
                {
                    // title: '门票名称',
                    title: this.$t('store.goods_name'),
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                    align: 'center',
                    fixed: 'left',
                    width: 180
                },
                {
                    // title: '金额',
                    title: this.$t('store.goods_money'),
                    dataIndex: 'price',
                    scopedSlots: { customRender: 'price' },
                    align: 'center',
                    width:100
                },
                {
                    // title: '库存',
                    title: `${this.$t('store.inventory')}/${this.$t('store.sales_volume')}`,
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' },
                    width:100
                },
                {
                    // title: '销售时段',
                    title: this.$t('store.sales_period'),
                    align: 'center',
                    width: 240,
                    scopedSlots: { customRender: 'sales_period' }
                }
            ], // 表格列
            dataSource: [], // 表格数据
            selectedRowKeys: [],
            bindKeys: [] // 已绑定门票id
        };
    },
    watch: {
        selectedRowKeys: {
            handler (newVal, oldVal) {
                console.log(newVal, oldVal)
            }
        }
    },
    methods: {
        onSelectChange (value) {
            this.selectedRowKeys = value
        },
        show (ids) {
            this.visible = true
            this.selectedRowKeys = ids
            this.bindKeys = ids
            this.getListData();
            this.getGoodsTypeList();
        },
        // 获取列表数据
        getListData() {
            let data = {
                page: 1,
                limit: 999
            };
            this.spinning = true;
            this.$request.get({ url: 'getGoodsList', data }).then(res => {
                this.dataSource = res.data.data;
                this.spinning = false;
            });
        },
        // 获取门票全部分类
        getGoodsTypeList() {
            this.$request.get({ url: 'getGoodsTypeList' }).then(res => {
                this.typeList = res.data;
            });
        },
        handleSearch() {
            this.getListData();
        },
        handleOk () {
            this.$request.post({ url: 'submitForumGoodsBind', data: { goods_ids: this.selectedRowKeys.join(',') } }).then((res) => {
                this.$emit('reset')
                this.visible = false
                this.$message.success('操作成功')
            })
        }
    },
    computed: {
       rowSelection() {
         const { selectedRowKeys } = this
            return {
                selectedRowKeys, //一定要加上这一行，清楚还会有效果
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRows = selectedRows
                    this.selectedRowKeys = selectedRowKeys
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: this.bindKeys.includes(record.id)
                    }
                })
            }
        }
    }
};
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
    margin-bottom: 10px !important;
}
.goods-item {
    border: 1px solid #e3e4e5;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
}
</style>
